import DOMPurify from "dompurify";
import { decodeHTML } from "./decodeHTML";

export const sanitizeDescription = (value) => {
  const html = value ?? "";
  // Current HTML can contain literal escaped tags; decode only legacy markup.
  const legacy =
    !/<[a-z!/]/i.test(html) &&
    /^\s*&lt;(?:p|h[1-6]|ul|ol|li|blockquote|br|hr|pre|code|strong|em|b|i|u|s|mark|sub|sup|a)(?:\s|\/?&gt;)/i.test(
      html,
    );
  return DOMPurify.sanitize(legacy ? decodeHTML(html) : html, {
    ALLOWED_TAGS: [
      "a",
      "b",
      "blockquote",
      "br",
      "code",
      "em",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hr",
      "i",
      "li",
      "mark",
      "ol",
      "p",
      "pre",
      "s",
      "strong",
      "sub",
      "sup",
      "u",
      "ul",
    ],
    ALLOWED_ATTR: ["href", "title", "start"],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });
};
